import { render, staticRenderFns } from "./VentasCaja.view.vue?vue&type=template&id=030f342d&"
import script from "./VentasCaja.view.vue?vue&type=script&lang=js&"
export * from "./VentasCaja.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports